import { GridData } from 'src/app/matrix-component/grid-list/gridData.model';

export class GridWithId
{
    comfortTypeId:number;
    grid:GridData;
    constructor(ct:number,g:GridData)
    {
        this.comfortTypeId=ct;
        this.grid=g;
    }
}